import { itx } from "../../../../src/translationItx/itx";
import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 1.0;
const DEFAULT_HEIGHT = 0.7;

const Washbasin: C1_FurnitureDefinition = {
  id: "washbasin",
  icon: <C1_FurnitureIcon kind="washbasin" />,
  description: { en: "Washbasin", de: "Waschbecken" },
  category: RoomType.Bathroom,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  originXPercentage: 50,
  originYPercentage: 0,
  autoRotate: true,

  properties: [
    {
      key: "mirrorCabinet",
      get label() { return itx("c1.ui.Spiegelschrank", "Spiegelschrank"); },
      type: "boolean",
      defaultValue: false,
    },
    {
      key: "baseCabinet",
      get label() { return itx("c1.ui.Unterschrank", "Unterschrank"); },
      type: "boolean",
      defaultValue: false,
    },
  ],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
    mirrorCabinet,
    baseCabinet,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const basinOffset = mirrorCabinet ? 0.1 * PX : 0;
    const cabinetOffset = 0.03 * PX;
    const inset = 0.04 * PX;
    const basinHeight = Math.max(0, height - basinOffset - inset * 2);

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={50}
        originYPercentage={0}
      >
        {mirrorCabinet && (
          <rect
            x={inset}
            y={0.02 * PX}
            width={Math.max(0, width - inset * 2)}
            height={0.08 * PX}
            rx={0.01 * PX}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
        )}
        <g transform={`translate(0 ${basinOffset})`}>
          <rect
            x={inset}
            y={inset}
            width={Math.max(0, width - inset * 2)}
            height={basinHeight}
            rx={Math.min(0.12 * PX, width / 2, basinHeight / 2)}
            fill={finalFillColor}
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth * 2}
          />
          {showDetails && (
            <>
              <ellipse
                cx={width / 2}
                cy={inset + basinHeight * 0.55}
                rx={width * 0.28}
                ry={basinHeight * 0.29}
                fill="none"
                stroke={finalStrokeColor}
                strokeWidth={finalStrokeWidth}
              />
              <circle cx={width / 2} cy={inset + basinHeight * 0.16} r={0.03 * PX} fill={finalStrokeColor} />
            </>
          )}
        </g>
        {baseCabinet && (
          <path
            d={`M ${inset - cabinetOffset} 0 V ${height + cabinetOffset} H ${width - inset + cabinetOffset} V 0`}
            fill="none"
            stroke={finalStrokeColor}
            strokeWidth={finalStrokeWidth}
            strokeDasharray="4 3"
          />
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default Washbasin;
